// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"_2jvHVGVpYI5SunmZAICrGh","linksWrapper":"D14t3Af-_tkkmlg_Wgh9C","passwordLabelWrapper":"_2HPM_xxLX60oqe3_y_NaR2","security":"lVrHZPQdvV7m2hcwT6J5U"};